import Value from './RegionBlogPostsSection'

export default {
	label: 'Region blogposts',
	group: 'content',
	defaultValue: {regionId: null},
	Value,
}
